import { rtkApi } from '@/shared/api/rtkApi';

export interface Step1Query {
  phoneNumber: string;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  region: string;
}

export interface Step2Query {
  registrationToken: string;
  nickname: string;
  password: string;
  birthDate?: string;
  vkLink?: string;
}

interface TokenResponse {
  registrationToken: string;
}

const createUsualAccountApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    step1: build.mutation<TokenResponse, Step1Query>({
      query: (data) => ({
        url: '/v1/superadmin/registration/step-1',
        method: 'POST',
        body: data,
      }),
    }),
    step2: build.mutation<TokenResponse, Step2Query>({
      query: (data) => ({
        url: '/v1/superadmin/registration/step-2',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useStep1Mutation, useStep2Mutation } = createUsualAccountApi;
